module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"owner":"Propriétaire","visibility":"Visibilité","topics":"Thématiques","publicationSites":"Portails","requestedPublicationSites":"Publications à valider","app":"Modèle d\u0027application"},"en":{"owner":"Owner","visibility":"Visibility","topics":"Topics","publicationSites":"Portals","requestedPublicationSites":"Requested publications","app":"Application model"}}')
  delete Component.options._Ctor
}
